import React from "react";
import {
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  DirectionsCar,
  DirectionsWalk,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import ConfigSectorsActioner from "../../../services/configSectors/actioner";
import { connect } from "react-redux";
import ConfigSectorContainer from "./ConfigSectorContainer";
import styled from "@emotion/styled";
import ParkkiTheme from "themes/ParkkiTheme";

const Title = styled.div`
  font-size: ${ParkkiTheme.fontSizes.small};
  font-weight: bolder;
  margin-top: ${ParkkiTheme.spacings.tiny};
  margin-bottom: ${ParkkiTheme.spacings.xsmall};
  font-family: "Source Sans Pro", sans-serif;
`;

function ConfigSectorsAreaContainer({ area, setAreaSelected, areaSelected }) {
  const handleClick = () => {
    setAreaSelected(area.id === areaSelected ? undefined : area.id);
  };

  return (
    <>
      <ListItemButton onClick={handleClick} sx={{}}>
        <ListItemIcon>
          {area?.type === "PARKANDFLOW" ? (
            <DirectionsCar />
          ) : (
            <DirectionsWalk />
          )}
        </ListItemIcon>
        <ListItemText primary={<Title>{area?.long_name}</Title>} />
        {area.id === areaSelected ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={area.id === areaSelected} timeout="auto" unmountOnExit>
        <ConfigSectorContainer />
      </Collapse>
    </>
  );
}

const mapStateToProps = (state) => ({
  areaSelected: state.ConfigSectors.areas.selected,
  sectorLoading: state.ConfigSectors.sectors.loading,
});

const mapDispatchToProps = (dispatch) => ({
  setAreaSelected: (id) => dispatch(ConfigSectorsActioner.setAreaSelected(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigSectorsAreaContainer);
